import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import CustomLocationPreview from '../../../../../ReusableFormSections/CustomLocationsSection/CustomLocationsPreview'

import { formatGeoTargetingToFE } from '../../formatters'

import { CUSTOM_LOCATIONS, GEO_TARGETING } from '../../fields'

import { choicesCountriesSelector } from '../../../../../../modules/selectors/choices'
import { lineItemSelector } from '../../../../../../modules/selectors/lineItems'
import { GEO_EXCLUSIONS } from '../../../../../ReusableFormFields/GeolocationsFields/fields'

const GeoTargetingSectionPreview = () => {
  const { t } = useTranslation()
  const lineItem = useSelector(lineItemSelector)
  const choicesCountries = useSelector(choicesCountriesSelector)

  const { [GEO_TARGETING]: geoTargeting, [GEO_EXCLUSIONS]: geoExclusions } = lineItem

  const { [CUSTOM_LOCATIONS]: customLocations } = geoTargeting

  const formattedGeoTargeting = useMemo(
    () => formatGeoTargetingToFE(geoTargeting, choicesCountries),
    [geoTargeting, choicesCountries]
  )

  const formattedGeoExclusions = useMemo(
    () => formatGeoTargetingToFE(geoExclusions, choicesCountries),
    [geoExclusions, choicesCountries]
  )

  return (
    <>
      <p>
        {!!formattedGeoTargeting.length
          ? formattedGeoTargeting.map(({ label, value }) => <span key={value}>{label}</span>)
          : null}
        <CustomLocationPreview customLocations={customLocations} />
      </p>

      {!!formattedGeoExclusions.length && (
        <p>
          <span>{t('Exclude: ')}</span>
          {formattedGeoExclusions.map(({ label, value }) => (
            <span key={value}>{label}</span>
          ))}
        </p>
      )}
    </>
  )
}

export default GeoTargetingSectionPreview
